import { getStrings, homeShellString } from "../i18n/strings";

type Strings = ReturnType<typeof getStrings>;

// The hero's copy block: category eyebrow, the page's single <h1>, one supporting line. Nothing
// else — the first screen has exactly one job (spec §五: "告诉用户这是你的 IP，这是它的风险"), so the
// old "No signup required" badge and the REST API / CLI / JavaScript SDK link row are gone from
// here. None of that content left the site: the CLI, the SDK and the Developer API all keep their
// full treatment in HomeDeveloperTools further down the page.
//
// Pure/stateless on purpose: this is also rendered at build time into web/index.html and every
// dist/{lang}/index.html (see scripts/homeSeoSnapshot.ts + vite.config.ts's SEO snapshot plugin), so
// it must never depend on state, effects, or the live query result.
export function HomeHero({ strings }: { strings: Strings }) {
  const t = <K extends Parameters<typeof homeShellString>[1]>(key: K) => homeShellString(strings, key);

  return (
    <header className="home-hero-intro">
      <p className="home-hero-intro__eyebrow">{t("homeHeroEyebrow")}</p>
      <h1 className="home-hero-intro__title">{t("homeHeroH1")}</h1>
      <p className="home-hero-intro__subtitle">{t("homeHeroSubtitle")}</p>
    </header>
  );
}
